import { rem } from 'polished'
import styled from 'styled-components'

export const DrawerContainerStyled = styled.div<{ minWidth?: string }>`
  position: fixed;
  left: auto;
  top: 0;
  right: 0;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 35vw;
  ${(props) => props.minWidth && `min-width: ${props.minWidth};`}
  outline: none;
  z-index: ${(props) => props.theme.zIndex.modal};
  overflow-y: auto;
  box-shadow: ${(props) => props.theme.shadows[2]};
  font-size: ${rem(16)};
  background: ${(props) => props.theme.colors.white};
`
